export default __webpack_public_path__ + "static/summer_containers5-add57913e007db802aba5ea2a8272f85.webp";